import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Game } from '../../models/communication/app-state.model';

export interface ButtonInGroup {
    label: string;
    initiallySelected?: boolean;
    action: (game: Game) => boolean;
}

/**
 * A component that renders a group of buttons, allowing one to be highlighted at a time.
 * Emits an event when a button is clicked, passing the action associated with the button.
 */
@Component({
    selector: 'app-button-group',
    imports: [CommonModule],
    templateUrl: './button-group.component.html',
    styleUrl: './button-group.component.scss'
})
export class ButtonGroupComponent implements OnInit {
    @Input()
    buttons: ButtonInGroup[] = [];

    @Output()
    readonly clicked = new EventEmitter<ButtonInGroup['action']>();

    protected highlightedButton?: ButtonInGroup;

    ngOnInit(): void {
        this.highlightedButton = this.buttons.find((button) => button.initiallySelected);
    }

    protected onClick(button: ButtonInGroup): void {
        if (button !== this.highlightedButton) {
            this.highlightedButton = button;
        }

        this.clicked.emit(button.action);
    }
}
